import { mapActions, mapGetters, mapMutations } from 'vuex';
import { MOUNTED, PUSH } from '../../stores/root/actions/_types';
import { SETUP_INIT_DATA, VIEW } from '../../stores/opoSearch/actions/_types';
import {
  DATE_PICKER_CANCEL,
  SET_INNER_MODAL_OPENED,
  TOGGLE_COLLAPSABLE_EXPANDED_ITEM,
} from '../../stores/opoSearch/mutations/_types';
import {
  SETUP_DATA,
  HANDLE_CLICK,
  RECORD_CLICK,
} from '../../stores/opoSearch/search/actions/_types';
import {
  CLOSE_FILTERS,
  OPEN_FILTERS,
  TOGGLE_FILTER_MENU,
} from '../../stores/opoSearch/search/mutations/_types';

export default {
  computed: {
    ...mapGetters('opo-search', [
      'datePicker',
      'location',
      'collapsableLinkList',
      'results',
      'noResults',
      'isLoading',
    ]),
    ...mapGetters('opo-search/search', {
      computedSearch: 'search',
    }),
    ...mapGetters('opo-search/search', ['metaInfo']),
  },
  serverPrefetch() {
    const { title, canonical, breadcrumbs, search, locationCoordinates, queryString } = this;

    return Promise.all([
      this[SETUP_DATA]({
        title,
        canonical,
        breadcrumbs,
        search,
      }),
      this[SETUP_INIT_DATA]({
        locationCoordinates,
        queryString,
      }),
    ]);
  },
  mounted() {
    const { title, canonical, breadcrumbs, search, locationCoordinates, queryString } = this;

    this[MOUNTED]();
    this[SETUP_DATA]({
      title,
      canonical,
      breadcrumbs,
      search,
    });
    this[SETUP_INIT_DATA]({
      locationCoordinates,
      queryString,
    });
    this[VIEW]();
  },
  methods: {
    ...mapActions([MOUNTED, PUSH]),
    ...mapActions('opo-search', [SETUP_INIT_DATA, VIEW]),
    ...mapActions('opo-search/search', [SETUP_DATA, HANDLE_CLICK, RECORD_CLICK]),
    ...mapMutations('opo-search/search', [TOGGLE_FILTER_MENU, OPEN_FILTERS, CLOSE_FILTERS]),
    ...mapMutations('opo-search', [
      SET_INNER_MODAL_OPENED,
      TOGGLE_COLLAPSABLE_EXPANDED_ITEM,
      DATE_PICKER_CANCEL,
    ]),
  },
};
